import type { AppointmentStatus, TrackingStatus } from '@fv/models'

import { OppListPanel } from '../opp-panel/OppListPanel'
import { OppFilterPanel } from './FilterPanel'
import { OppListing } from './OppListing'
import { OppListingProvider } from './OppListingContextProvider'
import type { oppPageStatusMap } from './types'

type Mode = (typeof oppPageStatusMap)['active'][number]
type Props = {
  mode?: Mode
  trackingStatus?: TrackingStatus
  appointmentStatus?: AppointmentStatus
}
export const ActivePage = ({
  mode,
  trackingStatus,
  appointmentStatus,
}: Props) => {
  return (
    <OppListingProvider
      status={mode ?? 'confirmed'}
      page="active"
      trackingStatus={trackingStatus}
      appointmentStatus={appointmentStatus}
    >
      <OppFilterPanel
        items={[
          { label: 'Active', icon: 'truck-moving', to: '/active' },

          {
            label: 'Ready/Scheduled',
            icon: 'filter',
            to: '/active/ready',
          },
          {
            label: 'Picked Up',
            icon: 'filter',
            to: '/active/in-transit',
          },
          {
            label: 'Delivered',
            icon: 'filter',
            to: '/active/delivered',
          },
          {
            label: 'Appointment Required',
            icon: 'clock',
            to: '/active/appointment',
          },
          { label: 'Archived', icon: 'archive', to: '/active/archived' },
        ]}
      />
      <OppListing
        emptyText={`There are no ${mode ?? 'confirmed'} shipments in your list`}
      />
      <OppListPanel />
    </OppListingProvider>
  )
}
